module.exports = __webpack_public_path__ + "static/video-3-452c1013ae71a240f5b800d7b4be7484.jpg";